import PlaceModel         from '@models/map/PlaceModel';
import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';

/**
 * Supprime de la carte les formes qui ouvrent ce point d'intérêt.
 *
 * Toujours appelé AVANT la suppression du point d'intérêt lui-même : une forme dont la cible n'existe
 * plus reste cliquable et ne mène nulle part. `skipHistory` parce que l'annulation ne rendrait que la
 * forme, pas le point d'intérêt — proposer un Ctrl+Z qui ne défait que la moitié du geste serait pire
 * que de ne rien proposer.
 *
 * Partagé entre la liste et la fiche : les deux offrent la suppression, elles doivent nettoyer
 * pareil.
 */
export default async function deleteShapesFromPlace(place: PlaceModel) {
	const editor = currentEditorStore.get;

	const shapes = (editor?.getAllShapes() || []).filter(shape => {
		return (
			shape.action === 'open_place'
			&& (shape.entity as any)?.entity?.id === place.id
		);
	});

	await Promise.all(shapes.map(shape => editor.deleteShape(shape.id, { skipHistory: true })));

	return shapes.length;
}
